export default "__VITE_ASSET__DXpzYFrN__"